<template>
  <div class="home">
    <div class="ui column padded grid centered">
      <div class="row">
        <div class="three wide column">
          <div class="ui statistics">
            <div class="statistic">
              <div class="value">{{ totalRecords }}</div>
              <div class="label">Total Messages</div>
            </div>

            <div class="statistic red" href="#">
              <div class="value">0</div>
              <div class="label">To Action</div>
            </div>
            <div class="statistic blue">
              <div class="value">{{ totalRecords - 2 }}</div>
              <div class="label">Await</div>
            </div>
          </div>
        </div>
        <div class="twelve wide column">
          <div class="ui raised padded text segment">
            <h2 class="ui header">Plans</h2>
            <vue-markdown
              >This is the formal message. am a ~~tast~~ **test**.</vue-markdown
            >
            <vue-markdown>What about links within MDs??</vue-markdown>
            <form class="ui form" v-on:submit.prevent>
              <div class="field">
                <sui-input
                  fluid
                  placeholder="Search ..."
                  v-model="searchText"
                  v-on:keyup="getResults(1)"
                />
              </div>
            </form>
            <sui-table compact celled>
              <sui-table-header full-width>
                <sui-table-row>
                  <sui-table-header-cell>Last Modified</sui-table-header-cell>
                  <sui-table-header-cell>Name</sui-table-header-cell>
                  <sui-table-header-cell>Email</sui-table-header-cell>
                  <sui-table-header-cell>ID Number</sui-table-header-cell>
                  <sui-table-header-cell>Proposal Type</sui-table-header-cell>

                  <sui-table-header-cell vertical-align="right"
                    >Investable Balance</sui-table-header-cell
                  >
                  <sui-table-header-cell>Status</sui-table-header-cell>

                  <sui-table-header-cell></sui-table-header-cell>
                </sui-table-row>
              </sui-table-header>
              <sui-table-body>
                <sui-table-row v-for="c in results" :key="c.id">
                  <sui-table-cell>
                    {{ new Date(c.updatedAsAt) | moment("DD MMM YYYY") }}
                    <small>{{
                      new Date(c.updatedAsAt) | moment("HH:MM")
                    }}</small>
                  </sui-table-cell>
                  <sui-table-cell>{{
                    c.firstName + " " + c.lastName
                  }}</sui-table-cell>
                  <sui-table-cell>
                    <a :href="'mailto: c.primaryEmail'">{{ c.primaryEmail }}</a>
                  </sui-table-cell>
                  <sui-table-cell>{{ c.idNumber }}</sui-table-cell>
                  <sui-table-cell>Living Annuity</sui-table-cell>

                  <sui-table-cell vertical-align="right">{{
                    c.goals[0].inputCurrentSavings | numeralFormat("0,00.00a")
                  }}</sui-table-cell>
                  <sui-table-cell>
                    <div
                      v-if="c.firstName == 'Allan'"
                      class="ui small basic label green"
                    >
                      completed
                    </div>
                    <div
                      v-else-if="c.firstName == 'Bjorn'"
                      class="ui small basic label blue"
                    >
                      awaiting my signature
                    </div>
                    <div
                      v-else-if="c.firstName == 'Ivan'"
                      class="ui small basic label pink"
                    >
                      out for signature
                    </div>
                    <div
                      v-else-if="c.firstName == 'John'"
                      class="ui small basic label red"
                    >
                      declined
                    </div>
                    <div v-else class="ui small basic label">draft</div>
                  </sui-table-cell>

                  <sui-table-cell>
                    <sui-dropdown text="Action">
                      <sui-dropdown-menu>
                        <sui-dropdown-item
                          :to="{ name: 'editClient', params: { id: c.id } }"
                        >
                          <router-link
                            :to="{ name: 'editClient', params: { id: c.id } }"
                            >View Client Details</router-link
                          >
                        </sui-dropdown-item>
                        <sui-dropdown-item
                          v-if="c.goals[0].clientGoalResultsId != 0"
                          :to="{
                            name: 'postretirement',
                            params: { id: c.goals[0].clientGoalResultsId },
                          }"
                        >
                          <router-link
                            :to="{
                              name: 'postretirement',
                              params: { id: c.goals[0].clientGoalResultsId },
                            }"
                            >View Plan</router-link
                          >
                        </sui-dropdown-item>
                      </sui-dropdown-menu>
                    </sui-dropdown>
                  </sui-table-cell>
                </sui-table-row>
              </sui-table-body>
              <sui-table-footer full-width>
                <sui-table-row>
                  <sui-table-header-cell colspan="2">
                    <router-link to="/postretirement">
                      <sui-button floated="left" size="small" primary labeled>
                        <sui-icon name="user" />Add Proposal
                      </sui-button>
                    </router-link>
                  </sui-table-header-cell>
                  <sui-table-header-cell colspan="4">
                    <sui-menu
                      v-if="totalPages > 1"
                      v-sui-floated:right
                      pagination
                    >
                      <a is="sui-menu-item" @click.prevent="getResults(1)">
                        <sui-icon name="left chevron" />First Page
                      </a>
                      <a
                        is="sui-menu-item"
                        v-if="
                          currentPageNr - 4 > 0 &&
                          currentPageNr - 4 <= totalPages
                        "
                        @click.prevent="getResults(currentPageNr - 4)"
                        >{{ currentPageNr - 4 }}</a
                      >
                      <a
                        is="sui-menu-item"
                        v-if="
                          currentPageNr - 3 > 0 &&
                          currentPageNr - 3 <= totalPages
                        "
                        @click.prevent="getResults(currentPageNr - 3)"
                        >{{ currentPageNr - 3 }}</a
                      >
                      <a
                        is="sui-menu-item"
                        v-if="
                          currentPageNr - 2 > 0 &&
                          currentPageNr - 2 <= totalPages
                        "
                        @click.prevent="getResults(currentPageNr - 2)"
                        >{{ currentPageNr - 2 }}</a
                      >
                      <a
                        is="sui-menu-item"
                        v-if="
                          currentPageNr - 1 > 0 &&
                          currentPageNr - 1 <= totalPages
                        "
                        @click.prevent="getResults(currentPageNr - 1)"
                        >{{ currentPageNr - 1 }}</a
                      >
                      <div is="sui-menu-item">
                        <strong>{{ currentPageNr }}</strong>
                      </div>

                      <a
                        is="sui-menu-item"
                        v-if="
                          currentPageNr + 1 > 0 &&
                          currentPageNr + 1 <= totalPages
                        "
                        @click.prevent="getResults(currentPageNr + 1)"
                        >{{ currentPageNr + 1 }}</a
                      >
                      <a
                        is="sui-menu-item"
                        v-if="
                          currentPageNr + 2 > 0 &&
                          currentPageNr + 2 <= totalPages
                        "
                        @click.prevent="getResults(currentPageNr + 2)"
                        >{{ currentPageNr + 2 }}</a
                      >
                      <a
                        is="sui-menu-item"
                        v-if="
                          currentPageNr + 3 > 0 &&
                          currentPageNr + 3 <= totalPages
                        "
                        @click.prevent="getResults(currentPageNr + 3)"
                        >{{ currentPageNr + 3 }}</a
                      >
                      <a
                        is="sui-menu-item"
                        v-if="
                          currentPageNr + 4 > 0 &&
                          currentPageNr + 4 <= totalPages
                        "
                        @click.prevent="getResults(currentPageNr + 4)"
                        >{{ currentPageNr + 4 }}</a
                      >

                      <a
                        is="sui-menu-item"
                        @click.prevent="getResults(totalPages)"
                      >
                        <sui-icon name="right chevron" />Last Page
                      </a>
                    </sui-menu>
                  </sui-table-header-cell>
                </sui-table-row>
              </sui-table-footer>
            </sui-table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { searchClients, BaseUrl } from "@/gateway";
import axios from "axios";

import VueMarkdown from "vue-markdown";
export default {
  components: {
    VueMarkdown,
  },
  name: "ClientList",
  props: {
    msg: String,
  },
  data() {
    return {
      results: [],
      searchText: "",
      loading: false,
      totalRecords: 0,
      currentPageNr: 1,
      currentPageSize: 8,
      totalPages: 1,
    };
  },
  methods: {
    async getResults(pageNr) {
      this.loading = true;
      var response = await searchClients({
        searchText: this.searchText,
        pageSize: this.currentPageSize,
        pageNr: pageNr,
      });
      this.totalRecords = response.totalRecords;
      this.totalPages = response.totalPages;
      this.currentPageNr = response.currentPageNr;
      this.results = response.result;
      this.loading = false;
    },
    async download() {
      console.log("downloading file");
      //const response = await downloadFile({ Id: "1" });
      axios({
        url: BaseUrl + "pdf/download?Id=1",
        method: "GET",
        responseType: "blob", // important
      })
        .then(function (response) {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", "test.pdf");
          document.body.appendChild(link);
          link.click();
        })
        .catch(function (error) {});
    },
  },
  mounted: function () {
    this.getResults(1);
  },
};
</script>
